import api from "./api";

const getCustomCollections = async (params) => {
    try {
        const response = await api.get('/custom-collections', { params });
        return response.data;
    } catch (error) {
        console.error("API Error in getCustomCollections:", error);
        throw error;
    }
};

const createCustomCollection = async (data) => {
    console.log("createCustomCollection called with:", data);
    try {
        const response = await api.post('/custom-collections', data);
        console.log("createCustomCollection response:", response);
        return response.data;
    } catch (error) {
        console.error("API Error in createCustomCollection:", error);
        throw error;
    }
};

const updateCustomCollection = async (id, data) => {
    const response = await api.put(`/custom-collections/${id}`, data);
    return response.data;
};

const deleteCustomCollection = async (id) => {
    const response = await api.delete(`/custom-collections/${id}`);
    return response.data;
};

export const customCollectionsService = {
    getAll: getCustomCollections,
    create: createCustomCollection,
    update: updateCustomCollection,
    delete: deleteCustomCollection
};
